"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var libzl_1 = require("../libzl/libzl");
var popup = null;
function sentenceCase(str) {
    return str[0].toUpperCase() + str.substr(1);
}
function getClientId() {
    if (window.location.hostname === "localhost") {
        return "LocalDevelopmentClient";
    }
    var brand = sentenceCase(process.env.REACT_APP_BRP_BRAND || "test");
    var environment = "Live";
    if (window.location.hostname.includes("-dev")) {
        environment = "Dev";
    }
    else if (window.location.hostname.includes("-test")) {
        environment = "Test";
    }
    return "BRP" + brand + environment;
}
function getTokenName() {
    return "token_" + getClientId() + "_" + libzl_1.evaluateStreamingEnv();
}
function processAuth() {
    var urlParams = new URLSearchParams(window.location.search);
    //Implicit authentication
    var state = urlParams.get('state');
    var accessToken = urlParams.get('access_token');
    if (state && accessToken) {
        try {
            //We've just been redirected back from auth
            if (state === localStorage.getItem('state')) {
                console.log('Successfully retrieved token from ', state, localStorage.getItem('state'));
                localStorage.setItem(getTokenName(), accessToken);
                localStorage.removeItem('state');
            }
            else {
                console.error('State returned did not match original state: ' + state + ' != ' + localStorage.getItem('state'));
                localStorage.removeItem('state');
            }
        }
        catch (_a) {
            console.log("local storage not available");
        }
        window.close();
    }
}
exports.processAuth = processAuth;
function forceReauth() {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var tokenName, scope, request, json, e_1, listener_1, timeout_1, token, e_2, state, onStorageChange, onCloseEvent, checkPopupBlocker, implicitFlowURL, width, height, top, left;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenName = getTokenName();
                    try {
                        localStorage.removeItem(tokenName);
                        localStorage.removeItem(tokenName + "_expires");
                        localStorage.removeItem(tokenName + "_scopes");
                    }
                    catch (_b) {
                    }
                    scope = "renderingservice.brp." + libzl_1.evaluateStreamingEnv() + ".access";
                    if (!(window.location.hostname !== "localhost")) return [3 /*break*/, 6];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch("/auth/getToken?scope=" + encodeURIComponent(scope))];
                case 2:
                    request = _a.sent();
                    if (!request.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, request.json()];
                case 3:
                    json = _a.sent();
                    try {
                        localStorage.setItem(tokenName, json.access_token);
                        localStorage.setItem(tokenName + "_scopes", json.scopes);
                        localStorage.setItem(tokenName + "_expires", json.expires);
                    }
                    catch (_c) {
                        console.log("Failed to store access token in local storage");
                    }
                    resolve(json.access_token);
                    return [2 /*return*/];
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    console.warn("Failed to request a token from doorman, falling back to implicit", e_1);
                    return [3 /*break*/, 6];
                case 6:
                    if (!window.parent) return [3 /*break*/, 11];
                    listener_1 = undefined;
                    timeout_1 = undefined;
                    _a.label = 7;
                case 7:
                    _a.trys.push([7, 9, 10, 11]);
                    return [4 /*yield*/, Promise.race([
                            new Promise(function (resolve) {
                                listener_1 = function (ev) {
                                    var data = JSON.parse(ev.data);
                                    if (data.event === "zl_auth_token") {
                                        try {
                                            localStorage.setItem(tokenName, data.token);
                                        }
                                        catch (_a) {
                                            console.log("Failed to store token in localStorage");
                                        }
                                        resolve(data.token);
                                        console.log("Recieved token from parent page", data.token);
                                    }
                                    else {
                                        console.log("Ignored");
                                    }
                                };
                                window.addEventListener("message", listener_1);
                                window.parent.postMessage(JSON.stringify({ event: "zl_get_auth_token", scope: scope }), "*");
                                console.log("Sent request for auth token to parent page", scope);
                            }),
                            new Promise(function (resolve) {
                                timeout_1 = setTimeout(function () {
                                    console.log("Timeout getting token from parent page");
                                    resolve();
                                }, 500);
                            })
                        ])];
                case 8:
                    token = _a.sent();
                    if (token) {
                        resolve(token);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 11];
                case 9:
                    e_2 = _a.sent();
                    console.log("Error attempting to get token from parent page", e_2);
                    return [3 /*break*/, 11];
                case 10:
                    if (timeout_1 !== undefined) {
                        clearTimeout(timeout_1);
                    }
                    if (listener_1 !== undefined) {
                        window.removeEventListener("message", listener_1);
                    }
                    return [7 /*endfinally*/];
                case 11:
                    state = (Math.random() + 1).toString(36).substr(2, 10);
                    try {
                        localStorage.setItem('state', state);
                    }
                    catch (_d) {
                        console.log("Failed to store state to local storage");
                    }
                    onStorageChange = function (ev) {
                        if (ev.key === getTokenName()) {
                            window.addEventListener('storage', onStorageChange);
                            if (popup) {
                                popup.removeEventListener('close', onCloseEvent);
                                popup.close();
                                popup = null;
                            }
                            if (ev.newValue) {
                                resolve(ev.newValue);
                            }
                            else {
                                reject();
                            }
                        }
                    };
                    onCloseEvent = function () {
                        popup = null;
                        window.removeEventListener('storage', onStorageChange);
                        reject();
                    };
                    checkPopupBlocker = function () {
                        alert("Attempting to show an authentication dialog, has it been blocked?");
                        reject();
                    };
                    window.addEventListener('storage', onStorageChange);
                    implicitFlowURL = 'https://authentication.zlthunder.net/api/v1/implicit?response_type=token' +
                        ("&client_id=" + getClientId()) +
                        ("&redirect_url=" + encodeURIComponent(window.location.href)) +
                        ("&scope=" + scope) +
                        ("&state=" + state);
                    width = 450;
                    height = 650;
                    top = ((window.outerHeight / 2) + window.screenY) - (height / 2);
                    left = ((window.outerWidth / 2) + window.screenX) - (width / 2);
                    popup = window.open(implicitFlowURL, "Log-In", "width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
                    if (popup) {
                        popup.addEventListener('close', onCloseEvent);
                        popup.focus();
                        setTimeout(function () {
                            if (popup === null || popup.closed) {
                                checkPopupBlocker();
                            }
                        }, 10);
                    }
                    else {
                        checkPopupBlocker();
                    }
                    return [2 /*return*/];
            }
        });
    }); });
}
exports.forceReauth = forceReauth;
function getToken() {
    if (!["stage", "assetpreview", "prelive"].includes(libzl_1.evaluateStreamingEnv())) {
        return undefined;
    }
    try {
        var tokenName = getTokenName();
        var token = localStorage.getItem(tokenName);
        var expires = localStorage.getItem(tokenName + "_expires");
        if (token === "undefined" || (expires && Date.parse(expires) < Date.now())) {
            localStorage.removeItem(tokenName);
            localStorage.removeItem(tokenName + "_expires");
            localStorage.removeItem(tokenName + "_scopes");
        }
        else if (token) {
            return token;
        }
    }
    catch (_a) {
        console.log("cannot get cached token because local storage is unavailable");
    }
    return undefined;
}
exports.getToken = getToken;
//# sourceMappingURL=auth.js.map